export interface AppSpecs {
  'specs.funnel.TemplatesGalleryEnableSortingDesktop': 'true' | 'false';
  'specs.funnel.TemplatesGalleryEnableFilters': 'true' | 'false';
  'specs.TemplateCMS.book_templates-page-2-0_sports-fitness-main-cat': 'true' | 'false';
  'specs.funnel.TemplatesGalleryEnableBanner': 'true' | 'false';
  'specs.funnel.TemplatesGalleryUseReactDomHydrate': 'true' | 'false';
  'specs.funnel.TemplatesGalleryNewMobileFlow': 'true' | 'false';
  'specs.funnel.TemplatesGallerySendEmailViaBiQuery': 'true' | 'false';
  'specs.funnel.UseBusinessTermToBookCategoryMapping': 'true' | 'false';
  'specs.funnel.TemplatesGalleryShowOnePageCategory': 'true' | 'false';
  'specs.funnel.TemplatesGalleryReverseTemplateButtonsOrder': 'true' | 'false';
}

export const defaultAppSpecs: AppSpecs = {
  'specs.funnel.TemplatesGalleryEnableSortingDesktop': 'false',
  'specs.funnel.TemplatesGalleryEnableFilters': 'false',
  'specs.TemplateCMS.book_templates-page-2-0_sports-fitness-main-cat': 'false',
  'specs.funnel.TemplatesGalleryEnableBanner': 'false',
  'specs.funnel.TemplatesGalleryUseReactDomHydrate': 'false',
  'specs.funnel.TemplatesGalleryNewMobileFlow': 'false',
  'specs.funnel.TemplatesGallerySendEmailViaBiQuery': 'false',
  'specs.funnel.UseBusinessTermToBookCategoryMapping': 'false',
  'specs.funnel.TemplatesGalleryShowOnePageCategory': 'false',
  'specs.funnel.TemplatesGalleryReverseTemplateButtonsOrder': 'false',
};
